import {
  GET_PROCESS,
  GET_PROCESS_SUCCESS,
  GET_PROCESS_ERROR,
  EXECUTE_PROCESS,
  EXECUTE_PROCESS_SUCCESS,
  EXECUTE_PROCESS_ERROR,
  UPDATE_PROCESS_DETAILS_STATE,
} from "../actions";

export const getProcess = (processId, activityInfo) => ({
  type: GET_PROCESS,
  payload: { processId, activityInfo },
});

export const getProcessSuccess = (process) => ({
  type: GET_PROCESS_SUCCESS,
  payload: process,
});

export const getProcessError = (message) => ({
  type: GET_PROCESS_ERROR,
  payload: { message },
});

export const executeProcess = (processId) => ({
  type: EXECUTE_PROCESS,
  payload: { processId },
});

export const executeProcessSuccess = (successMessage) => ({
  type: EXECUTE_PROCESS_SUCCESS,
  payload: { successMessage },
});

export const executeProcessError = (message) => ({
  type: EXECUTE_PROCESS_ERROR,
  payload: { message },
});

export const updateProcessDetailsState = (updatedValues) => ({
  type: UPDATE_PROCESS_DETAILS_STATE,
  payload: { updatedValues },
});
